/**
 * @generated SignedSource<<43c120e1be091916d00f87f900b67066>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING";
export type ReadingModeFullScreenQuery$variables = {
  createdAfter?: string | null;
  createdBefore?: string | null;
  isProjectUpdates: boolean;
  stateFilter?: UpdateStateFilter | null;
  workspaceUUID: string;
};
export type ReadingModeFullScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ReadingModeInternalsGoalPagination_data" | "ReadingModeInternalsProjectPagination_data">;
};
export type ReadingModeFullScreenQuery = {
  response: ReadingModeFullScreenQuery$data;
  variables: ReadingModeFullScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdAfter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdBefore"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectUpdates"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v5 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "createdAfter"
},
v6 = {
  "kind": "Variable",
  "name": "createdBefore",
  "variableName": "createdBefore"
},
v7 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v8 = {
  "kind": "Variable",
  "name": "workspaceUUID",
  "variableName": "workspaceUUID"
},
v9 = [
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  },
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUpdate"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v15 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v16 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v17 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v18 = {
  "kind": "ScalarField",
  "name": "picture"
},
v19 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v20 = {
  "kind": "ScalarField",
  "name": "name"
},
v21 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v22 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v13/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/)
      ]
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "ari"
},
v24 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v13/*: any*/)
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "watching"
},
v26 = {
  "kind": "ScalarField",
  "name": "key"
},
v27 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v28 = [
  (v13/*: any*/),
  (v27/*: any*/)
],
v29 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v30 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v31 = {
  "kind": "ScalarField",
  "name": "description"
},
v32 = {
  "args": (v30/*: any*/),
  "concreteType": "TagConnection",
  "kind": "LinkedField",
  "name": "tagsWatchedByUser",
  "plural": false,
  "selections": [
    {
      "concreteType": "TagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v20/*: any*/),
            (v14/*: any*/),
            (v31/*: any*/),
            {
              "kind": "ScalarField",
              "name": "projectUsageCount"
            },
            {
              "kind": "ScalarField",
              "name": "goalUsageCount"
            },
            {
              "kind": "ScalarField",
              "name": "helpPointerUsageCount"
            },
            {
              "kind": "ScalarField",
              "name": "watcherCount"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "tagsWatchedByUser(first:3)"
},
v33 = {
  "args": (v30/*: any*/),
  "concreteType": "TeamConnection",
  "kind": "LinkedField",
  "name": "teamsWatchedByUser",
  "plural": false,
  "selections": [
    {
      "concreteType": "TeamEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v20/*: any*/),
            {
              "kind": "ScalarField",
              "name": "teamId"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "teamsWatchedByUser(first:3)"
},
v34 = {
  "concreteType": "Project",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v14/*: any*/),
    (v24/*: any*/),
    (v13/*: any*/),
    (v25/*: any*/),
    {
      "kind": "ScalarField",
      "name": "private"
    },
    {
      "concreteType": "IconURIs",
      "kind": "LinkedField",
      "name": "iconUrl",
      "plural": false,
      "selections": [
        {
          "concreteType": "ThemeURIs",
          "kind": "LinkedField",
          "name": "square",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "light"
            },
            {
              "kind": "ScalarField",
              "name": "dark"
            },
            {
              "kind": "ScalarField",
              "name": "transparent"
            }
          ]
        }
      ]
    },
    (v26/*: any*/),
    (v20/*: any*/),
    {
      "concreteType": "ProjectUpdate",
      "kind": "LinkedField",
      "name": "latestUserUpdate",
      "plural": false,
      "selections": (v28/*: any*/)
    },
    (v29/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/)
  ]
},
v35 = {
  "concreteType": "UserViews",
  "kind": "LinkedField",
  "name": "views",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "viewCount"
    },
    {
      "kind": "ScalarField",
      "name": "objectType"
    },
    {
      "kind": "ScalarField",
      "name": "objectId"
    },
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "viewed"
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v37 = {
  "concreteType": "ProjectChangelogItem",
  "kind": "LinkedField",
  "name": "changelog",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "newValue"
    },
    {
      "kind": "ScalarField",
      "name": "oldValue"
    },
    (v13/*: any*/)
  ]
},
v38 = {
  "kind": "ScalarField",
  "name": "type"
},
v39 = {
  "kind": "ScalarField",
  "name": "summary"
},
v40 = [
  (v26/*: any*/),
  (v23/*: any*/),
  (v13/*: any*/)
],
v41 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v20/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/)
    ]
  },
  (v17/*: any*/),
  (v13/*: any*/)
],
v42 = {
  "kind": "ScalarField",
  "name": "count"
},
v43 = {
  "concreteType": "LearningConnection",
  "kind": "LinkedField",
  "name": "learnings",
  "plural": false,
  "selections": [
    {
      "concreteType": "LearningEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Learning",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            (v14/*: any*/),
            (v13/*: any*/),
            (v39/*: any*/),
            (v31/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v23/*: any*/),
                {
                  "concreteType": "Project",
                  "kind": "LinkedField",
                  "name": "project",
                  "plural": false,
                  "selections": (v40/*: any*/)
                },
                {
                  "concreteType": "Goal",
                  "kind": "LinkedField",
                  "name": "goal",
                  "plural": false,
                  "selections": (v40/*: any*/)
                },
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "creator",
                  "plural": false,
                  "selections": (v41/*: any*/)
                },
                (v27/*: any*/),
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "lastEditedBy",
                  "plural": false,
                  "selections": (v41/*: any*/)
                },
                {
                  "kind": "ScalarField",
                  "name": "lastEditedDate"
                }
              ],
              "type": "Highlight",
              "abstractKey": "__isHighlight"
            }
          ]
        }
      ]
    },
    (v42/*: any*/)
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v45 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v44/*: any*/),
            (v23/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v27/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v18/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/),
                    (v19/*: any*/)
                  ]
                },
                (v13/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ]
},
v46 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v20/*: any*/)
      ]
    },
    (v13/*: any*/)
  ]
},
v47 = {
  "kind": "ScalarField",
  "name": "label"
},
v48 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v49 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v51 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v47/*: any*/),
  (v49/*: any*/),
  {
    "alias": "tooltip",
    "args": (v50/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v50/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v48/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v52 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v51/*: any*/)
},
v53 = {
  "alias": "projectStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v54 = {
  "kind": "ScalarField",
  "name": "value"
},
v55 = {
  "concreteType": "CompletionProjectState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v54/*: any*/),
    (v47/*: any*/),
    (v49/*: any*/)
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "archived"
},
v57 = {
  "kind": "ScalarField",
  "name": "title"
},
v58 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v56/*: any*/),
    (v57/*: any*/),
    (v39/*: any*/),
    (v13/*: any*/),
    (v11/*: any*/)
  ]
},
v59 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v51/*: any*/)
},
v60 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "oldState",
  "plural": false,
  "selections": [
    (v47/*: any*/),
    (v49/*: any*/),
    (v53/*: any*/),
    (v55/*: any*/)
  ]
},
v61 = {
  "concreteType": "MilestoneConnection",
  "kind": "LinkedField",
  "name": "milestones",
  "plural": false,
  "selections": [
    {
      "concreteType": "MilestoneEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Milestone",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v13/*: any*/),
            (v57/*: any*/),
            {
              "kind": "ScalarField",
              "name": "targetDate"
            },
            {
              "kind": "ScalarField",
              "name": "targetDateType"
            },
            {
              "kind": "ScalarField",
              "name": "status"
            }
          ]
        }
      ]
    },
    (v42/*: any*/)
  ]
},
v62 = {
  "kind": "ScalarField",
  "name": "url"
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v62/*: any*/),
        {
          "concreteType": "Goal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            (v26/*: any*/),
            (v13/*: any*/)
          ]
        }
      ],
      "type": "GoalUpdate"
    }
  ],
  "type": "Update",
  "abstractKey": "__isUpdate"
},
v64 = [
  (v13/*: any*/)
],
v65 = {
  "concreteType": "Goal",
  "kind": "LinkedField",
  "name": "goal",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v14/*: any*/),
    (v24/*: any*/),
    (v13/*: any*/),
    (v25/*: any*/),
    {
      "concreteType": "Goal",
      "kind": "LinkedField",
      "name": "parentGoal",
      "plural": false,
      "selections": (v64/*: any*/)
    },
    (v26/*: any*/),
    (v20/*: any*/),
    {
      "concreteType": "GoalIcon",
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        (v26/*: any*/),
        {
          "kind": "ScalarField",
          "name": "appearance"
        }
      ]
    },
    {
      "concreteType": "GoalUpdate",
      "kind": "LinkedField",
      "name": "latestUserUpdate",
      "plural": false,
      "selections": (v28/*: any*/)
    },
    (v29/*: any*/),
    {
      "concreteType": "GoalConnection",
      "kind": "LinkedField",
      "name": "subGoals",
      "plural": false,
      "selections": [
        (v42/*: any*/)
      ]
    },
    {
      "concreteType": "MetricTargetConnection",
      "kind": "LinkedField",
      "name": "metricTargets",
      "plural": false,
      "selections": [
        {
          "concreteType": "MetricTargetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "MetricTarget",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "startValue"
                },
                {
                  "kind": "ScalarField",
                  "name": "targetValue"
                },
                (v13/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v32/*: any*/),
    (v33/*: any*/)
  ]
},
v66 = {
  "kind": "ScalarField",
  "name": "score"
},
v67 = {
  "alias": "goalStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v68 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v69 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v68/*: any*/),
    (v49/*: any*/),
    (v54/*: any*/),
    (v66/*: any*/)
  ]
},
v70 = [
  (v54/*: any*/),
  (v13/*: any*/)
],
v71 = {
  "concreteType": "GoalMetricUpdateConnection",
  "kind": "LinkedField",
  "name": "metricUpdate",
  "plural": false,
  "selections": [
    {
      "concreteType": "GoalMetricUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "GoalMetricUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "newStartValue"
            },
            {
              "kind": "ScalarField",
              "name": "newTargetValue"
            },
            {
              "concreteType": "MetricValue",
              "kind": "LinkedField",
              "name": "newValue",
              "plural": false,
              "selections": (v70/*: any*/)
            },
            {
              "concreteType": "Metric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                (v20/*: any*/),
                (v38/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "subType"
                },
                (v56/*: any*/)
              ]
            },
            {
              "concreteType": "MetricValue",
              "kind": "LinkedField",
              "name": "oldValue",
              "plural": false,
              "selections": (v70/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v72 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "newProgress",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    {
      "kind": "ScalarField",
      "name": "percentage"
    }
  ]
},
v73 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v56/*: any*/),
    (v14/*: any*/),
    (v57/*: any*/),
    (v39/*: any*/),
    (v13/*: any*/)
  ]
},
v74 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "oldState",
  "plural": false,
  "selections": [
    (v68/*: any*/),
    (v49/*: any*/),
    (v66/*: any*/),
    (v67/*: any*/),
    (v69/*: any*/)
  ]
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v62/*: any*/)
      ],
      "type": "GoalUpdate"
    }
  ],
  "type": "Update",
  "abstractKey": "__isUpdate"
},
v76 = {
  "kind": "InlineFragment",
  "selections": (v64/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v77 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v78 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v79 = [
  "createdBefore",
  "createdAfter",
  "workspaceUUID",
  "stateFilter"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "FragmentSpread",
            "name": "ReadingModeInternalsProjectPagination_data"
          }
        ]
      },
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "FragmentSpread",
            "name": "ReadingModeInternalsGoalPagination_data"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "allWatchedProjectUpdatesCount"
          },
          {
            "args": (v9/*: any*/),
            "concreteType": "UpdateConnection",
            "kind": "LinkedField",
            "name": "allWatchedProjectUpdates",
            "plural": false,
            "selections": [
              {
                "concreteType": "UpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v22/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v27/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v43/*: any*/),
                          (v23/*: any*/),
                          (v45/*: any*/),
                          (v44/*: any*/),
                          (v46/*: any*/),
                          (v52/*: any*/),
                          {
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v53/*: any*/),
                              (v47/*: any*/),
                              (v49/*: any*/),
                              (v55/*: any*/),
                              {
                                "alias": "projectState",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v39/*: any*/),
                          (v58/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v63/*: any*/)
                        ],
                        "type": "ProjectUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v22/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v65/*: any*/),
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v54/*: any*/),
                              (v66/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v49/*: any*/),
                              (v69/*: any*/)
                            ]
                          },
                          (v35/*: any*/),
                          (v27/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v23/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v44/*: any*/),
                          (v52/*: any*/),
                          (v39/*: any*/),
                          (v73/*: any*/),
                          (v59/*: any*/),
                          (v74/*: any*/),
                          (v75/*: any*/)
                        ],
                        "type": "GoalUpdate"
                      },
                      (v76/*: any*/)
                    ]
                  },
                  (v77/*: any*/)
                ]
              },
              (v78/*: any*/)
            ]
          },
          {
            "args": (v9/*: any*/),
            "filters": (v79/*: any*/),
            "handle": "connection",
            "key": "ReadingModeInternals_allWatchedProjectUpdates",
            "kind": "LinkedHandle",
            "name": "allWatchedProjectUpdates"
          }
        ]
      },
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "allWatchedGoalUpdatesCount"
          },
          {
            "args": (v9/*: any*/),
            "concreteType": "UpdateConnection",
            "kind": "LinkedField",
            "name": "allWatchedGoalUpdates",
            "plural": false,
            "selections": [
              {
                "concreteType": "UpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v22/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v27/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v43/*: any*/),
                          (v23/*: any*/),
                          (v45/*: any*/),
                          (v44/*: any*/),
                          (v46/*: any*/),
                          (v52/*: any*/),
                          {
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v53/*: any*/),
                              (v47/*: any*/),
                              (v49/*: any*/),
                              (v55/*: any*/)
                            ]
                          },
                          (v39/*: any*/),
                          (v58/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v63/*: any*/)
                        ],
                        "type": "ProjectUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v22/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v65/*: any*/),
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v54/*: any*/),
                              (v66/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v49/*: any*/),
                              (v69/*: any*/),
                              {
                                "alias": "goalState",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v35/*: any*/),
                          (v27/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v23/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v44/*: any*/),
                          (v52/*: any*/),
                          (v39/*: any*/),
                          (v73/*: any*/),
                          (v59/*: any*/),
                          (v74/*: any*/),
                          (v75/*: any*/)
                        ],
                        "type": "GoalUpdate"
                      },
                      (v76/*: any*/)
                    ]
                  },
                  (v77/*: any*/)
                ]
              },
              (v78/*: any*/)
            ]
          },
          {
            "args": (v9/*: any*/),
            "filters": (v79/*: any*/),
            "handle": "connection",
            "key": "ReadingModeInternals_allWatchedGoalUpdates",
            "kind": "LinkedHandle",
            "name": "allWatchedGoalUpdates"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8bfe61a191ab562749c0aa19e0f84af7",
    "id": null,
    "metadata": {},
    "name": "ReadingModeFullScreenQuery",
    "operationKind": "query",
    "text": "query ReadingModeFullScreenQuery(\n  $isProjectUpdates: Boolean!\n  $workspaceUUID: UUID!\n  $createdBefore: DateTime\n  $createdAfter: DateTime\n  $stateFilter: UpdateStateFilter\n) {\n  ...ReadingModeInternalsProjectPagination_data_2vmIz0 @include(if: $isProjectUpdates)\n  ...ReadingModeInternalsGoalPagination_data_2vmIz0 @skip(if: $isProjectUpdates)\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newState {\n    ...GoalState\n  }\n  oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalUpdateCardByline on Goal {\n  watching\n  tagsWatchedByUser(first: 3) {\n    edges {\n      node {\n        ...Tag\n        id\n      }\n    }\n  }\n  teamsWatchedByUser(first: 3) {\n    edges {\n      node {\n        id\n        name\n        teamId\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  newState {\n    value\n    score\n  }\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  views {\n    ...Views\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  views {\n    ...Views\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCard_3UosK1 on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    ...GoalUpdateCardByline\n    id\n  }\n  views {\n    ...ViewsTracker\n    id\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newState {\n    goalStateValue: value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment MissedProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  project {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop_PTxnb\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsSummary_data\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectMissedUpdateLabel on ProjectUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  project {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newState {\n    ...ProjectState\n  }\n  oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCardByline on Project {\n  watching\n  tagsWatchedByUser(first: 3) {\n    edges {\n      node {\n        ...Tag\n        id\n      }\n    }\n  }\n  teamsWatchedByUser(first: 3) {\n    edges {\n      node {\n        id\n        name\n        teamId\n      }\n    }\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateCardFooter on ProjectUpdate {\n  ari\n  updateType\n  missedUpdate\n  project {\n    ari\n    ...ProjectFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment ProjectUpdateCardHeader on ProjectUpdate {\n  project {\n    ...ProjectFollowButton\n    ...ProjectIcon\n    id\n    key\n    name\n  }\n}\n\nfragment ProjectUpdateCardInternal on ProjectUpdate {\n  id\n  project {\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop\n  ...ProjectUpdateSummary\n  ...ProjectUpdateCardContentExtras\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectUpdateCardTop on ProjectUpdate {\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  views {\n    ...Views\n    id\n  }\n  ...ProjectUpdateCreationDate\n  ...ProjectUpdateStatus\n  ...ProjectMissedUpdateLabel\n}\n\nfragment ProjectUpdateCardTop_PTxnb on ProjectUpdate {\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  views {\n    ...Views\n    id\n  }\n  ...ProjectMissedUpdateLabel\n  missedUpdate\n}\n\nfragment ProjectUpdateCard_3UosK1 on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  views {\n    ...ViewsTracker\n    id\n  }\n  project {\n    uuid\n    ...ProjectUpdateCardByline\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCreationDate on ProjectUpdate {\n  id\n  project {\n    key\n    id\n  }\n  creationDate\n  editDate\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateStatus on ProjectUpdate {\n  newDueDate {\n    ...TargetDate\n  }\n  newState {\n    projectStateValue: value\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateSummary on ProjectUpdate {\n  summary\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment ReadingModeInternalsGoalPagination_data_2vmIz0 on Query {\n  allWatchedGoalUpdatesCount(createdBefore: $createdBefore, createdAfter: $createdAfter, workspaceUUID: $workspaceUUID, stateFilter: $stateFilter)\n  allWatchedGoalUpdates(first: 15, createdBefore: $createdBefore, createdAfter: $createdAfter, workspaceUUID: $workspaceUUID, stateFilter: $stateFilter) {\n    edges {\n      node {\n        __typename\n        ...ReadingModeInternalsSingleUpdateCard\n        ... on GoalUpdate {\n          __typename\n          id\n          goal {\n            id\n            name\n          }\n          newState {\n            goalState: value\n          }\n          missedUpdate\n          updateType\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ReadingModeInternalsProjectPagination_data_2vmIz0 on Query {\n  allWatchedProjectUpdatesCount(createdBefore: $createdBefore, createdAfter: $createdAfter, workspaceUUID: $workspaceUUID, stateFilter: $stateFilter)\n  allWatchedProjectUpdates(first: 15, createdBefore: $createdBefore, createdAfter: $createdAfter, workspaceUUID: $workspaceUUID, stateFilter: $stateFilter) {\n    edges {\n      node {\n        __typename\n        ...ReadingModeInternalsSingleUpdateCard\n        ... on ProjectUpdate {\n          __typename\n          id\n          project {\n            id\n            name\n          }\n          newState {\n            projectState: value\n          }\n          missedUpdate\n          updateType\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ReadingModeInternalsSingleUpdateCard on Update {\n  __isUpdate: __typename\n  __typename\n  ... on ProjectUpdate {\n    ...ProjectUpdateCard_3UosK1\n  }\n  ... on GoalUpdate {\n    ...GoalUpdateCard_3UosK1\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment ViewersModalFragment on UserViews {\n  viewCount\n  objectType\n  objectId\n}\n\nfragment Views on UserViews {\n  viewCount\n  ...ViewsTooltipContent\n  ...ViewersModalFragment\n}\n\nfragment ViewsTooltipContent on UserViews {\n  viewCount\n  objectType\n  objectId\n}\n\nfragment ViewsTracker on UserViews {\n  viewed\n}\n"
  }
};
})();

(node as any).hash = "22dc57779181a0f6f0586c04c0335f3f";

export default node;
